<template>
  <div class="tag" :class="[color, { outline }, { icon: icon }]">
    {{ text }}
    <i v-if="icon" :class="icon" />
  </div>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: "black",
  },
  text: {
    type: String,
    required: true,
  },
  outline: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: "",
  },
});
</script>
